import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactMethodCardProps {
  icon: string;
  title: string;
  description: string;
  action: string;
  highlight?: boolean;
  onClick: () => void;
}

const ContactMethodCard = ({
  icon,
  title,
  description,
  action,
  highlight = false,
  onClick
}: ContactMethodCardProps) => {
  return (
    <div
      onClick={onClick}
      className={`group relative bg-card rounded-lg p-8 transition-all duration-base cursor-pointer ${
        highlight
          ? 'border-2 border-conversion shadow-partnership hover:shadow-lg'
          : 'border border-border shadow-sm hover:shadow-md'
      }`}
    >
      {highlight && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-conversion text-conversion-foreground text-xs font-headline font-semibold rounded-full">
          Most Popular
        </div>
      )}
      <div className={`inline-flex items-center justify-center w-14 h-14 rounded-full mb-6 transition-all duration-base ${
        highlight ? 'bg-conversion/10' : 'bg-muted group-hover:bg-primary/10'
      }`}>
        <Icon
          name={icon as any}
          size={28}
          variant="outline"
          className={highlight ? 'text-conversion' : 'text-primary'}
        />
      </div>
      <h3 className="text-xl font-headline font-bold text-foreground mb-3">
        {title}
      </h3>
      <p className="text-muted-foreground font-body mb-6 leading-relaxed">
        {description}
      </p>
      <button className={`w-full py-3 px-6 rounded-md font-headline font-semibold text-sm transition-all duration-base ${
        highlight
          ? 'bg-conversion text-conversion-foreground hover:bg-opacity-90 shadow-cta'
          : 'bg-primary text-primary-foreground hover:bg-secondary'
      }`}>
        {action}
      </button>
    </div>
  );
};

export default ContactMethodCard;